module.exports = __webpack_public_path__ + "img/MissionTripBG.12de2667.jpg";